module.exports = __webpack_public_path__ + "static/media/cart-light-grey.60dbb940.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/cart-light-grey.svg
// module id = 1952
// module chunks = 0